import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  DashboardFiltersMenu: {
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',

    '&__nav': {
      position: 'relative',
      minWidth: 320,
      height: 44,
      backgroundColor: 'rgba(11, 17, 32, 0.85)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      border: '1px solid rgba(14, 165, 233, 0.12)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 8,
      '&__list': {
        position: 'relative',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        zIndex: 1,
        '&__item': {
          position: 'relative',
          alignItems: 'center',
          display: 'flex',
          fontWeight: 500,
          justifyContent: 'center',
          flexDirection: 'column',
          padding: '5px 15px',
          textAlign: 'center',
          width: '100%',
          '&__icon': {
            color: theme.palette.white,
            opacity: 0.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.3rem',
            height: 36,
            lineHeight: '0.75px',
            borderRadius: '6px',
            transition: 'opacity 0.2s ease, background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease',
            width: 36,
            zIndex: 4,
          },
          '&__text': {
            position: 'absolute',
            color: 'black',
            fontWeight: 500,
            fontSize: '0.65rem',
            opacity: 0,
            padding: 3,
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            transition: 'opacity 0.2s ease',
            zIndex: 5,
            bottom: 45,
          },
          '&:hover': {
            cursor: 'pointer',
          },
          '&:hover &__icon, &.active &__icon': {
            opacity: 1,
            backgroundColor: 'rgba(6, 182, 212, 0.15)',
            color: '#06B6D4',
            transform: 'scale(1.08)',
          },
          '&.active &__icon': {
            boxShadow: '0 0 10px rgba(6, 182, 212, 0.25)',
          },
          '&:hover &__text, &.active &__text': {
            opacity: 1,
          },
        },
      },
    },
  },
}));

export { useStyles };
